<template>
  <component
    :is="tagName"
    class="font-extrabold tracking-tighter"
    :class="{
      'text-4xl lg:text-[62px]': size == 1,
      'text-3xl lg:text-[34px]': size == 2,
      'text-2xl lg:text-[22px]': size == 3,
      'text-xl lg:text-[22px] font-medium': size == 4,
    }"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts" setup>
type Props = {
  size?: 1 | 2 | 3 | 4;
  tagName?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};
withDefaults(defineProps<Props>(), {
  size: 1,
  tagName: 'h1',
});
</script>
